// Small formatting helpers shared by the demo views.
import type { ConditionStatus } from './tracking/collate.ts';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const ms = (iso: string): number => Date.parse(iso);
export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso); if (Number.isNaN(d.getTime())) return iso;
  return `${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}
export function fmtMonth(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso); if (Number.isNaN(d.getTime())) return iso;
  return `${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}
export const fmtNum = (v: number | null | undefined, decimals = 0): string => (v == null || !Number.isFinite(v) ? '—' : v.toFixed(decimals));
export function fmtDelta(v: number | null | undefined, decimals = 0): string {
  if (v == null || !Number.isFinite(v)) return '';
  if (Math.abs(v) < Math.pow(10, -decimals) / 2) return '±0';
  return `${v > 0 ? '+' : '−'}${Math.abs(v).toFixed(decimals)}`;
}
export function yearsBetween(a: string, b: string): number { return (ms(b) - ms(a)) / (365.25 * 86400000); }

/** CSS class suffix for a condition status (maps onto the console's semantic tokens). */
export const statusTone: Record<ConditionStatus, 'danger' | 'warn' | 'accent' | 'ok' | 'muted'> = {
  'needs-attention': 'danger', 'above-target': 'warn', improving: 'accent', controlled: 'ok', monitoring: 'muted',
};

// Validated categorical palette (dataviz reference instance, light mode).
export const SERIES = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300'];
